define("shared/components/shared/wistia-video", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="wistia_responsive_padding {{if @paddingClass @paddingClass ''}}" data-test-id="wistia-video-padding">
    <div class="wistia_responsive_wrapper {{if @wrapperClass @wrapperClass ''}}" data-test-id="wistia-video-wrapper">
      <div
        class="wistia_embed wistia_async_{{@videoId}} videoFoam=true {{if @embedClass @embedClass ''}}"
        data-test-id="wistia-video-embed"
      >
        <div class="wistia_swatch {{if @swatchClass @swatchClass ''}}" data-test-id="wistia-video-swatch">
          {{! template-lint-disable no-potential-path-strings }}
          <img
            alt
            aria-hidden="true"
            class={{if @coverClass @coverClass ""}}
            data-test-id="wistia-video-swatch-cover"
            onload="this.parentNode.style.opacity=1;"
            src={{this.videoSwatchImageUrl}}
          />
        </div>
      </div>
    </div>
  </div>
  */
  {
    "id": "8rPl6tDj",
    "block": "[[[10,0],[15,0,[29,[\"wistia_responsive_padding \",[52,[30,1],[30,1],\"\"]]]],[14,\"data-test-id\",\"wistia-video-padding\"],[12],[1,\"\\n  \"],[10,0],[15,0,[29,[\"wistia_responsive_wrapper \",[52,[30,2],[30,2],\"\"]]]],[14,\"data-test-id\",\"wistia-video-wrapper\"],[12],[1,\"\\n    \"],[10,0],[15,0,[29,[\"wistia_embed wistia_async_\",[30,3],\" videoFoam=true \",[52,[30,4],[30,4],\"\"]]]],[14,\"data-test-id\",\"wistia-video-embed\"],[12],[1,\"\\n      \"],[10,0],[15,0,[29,[\"wistia_swatch \",[52,[30,5],[30,5],\"\"]]]],[14,\"data-test-id\",\"wistia-video-swatch\"],[12],[1,\"\\n\"],[1,\"        \"],[10,\"img\"],[14,\"alt\",\"\"],[14,\"aria-hidden\",\"true\"],[15,0,[52,[30,6],[30,6],\"\"]],[14,\"data-test-id\",\"wistia-video-swatch-cover\"],[14,\"onload\",\"this.parentNode.style.opacity=1;\"],[15,\"src\",[30,0,[\"videoSwatchImageUrl\"]]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@paddingClass\",\"@wrapperClass\",\"@videoId\",\"@embedClass\",\"@swatchClass\",\"@coverClass\"],false,[\"if\"]]",
    "moduleName": "shared/components/shared/wistia-video.hbs",
    "isStrictMode": false
  });

  let WistiaVideoComponent = (_class = class WistiaVideoComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "wistiaVideo", _descriptor, this);

      this.wistiaVideo.setup(this.videoUrl);
      this.wistiaVideo.trackPercentWatched(this.args.videoId, this.args.trackPayload || {});
      this.videoId = this.args.videoId;
    }

    willDestroy() {
      super.willDestroy(...arguments);
      this.wistiaVideo.revoke(this.videoId);
    }

    get videoUrl() {
      return `https://fast.wistia.com/embed/medias/${this.args.videoId}.jsonp`;
    }

    get videoSwatchImageUrl() {
      return this.args.swatchImageUrl || `https://fast.wistia.com/embed/medias/${this.args.videoId}/swatch`;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "wistiaVideo", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = WistiaVideoComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WistiaVideoComponent);
});